import React from "react";

export function Step1({ ...props }) {
  return (
    <>
      <div className="block w-full bg-neutral-white border border-gray-10 rounded-lg shadow-base pt-8 px-6 md:px-8 pb-10">
        <h4 className="text-gray-70 font-bold">Descripción</h4>
        <hr className="border-gray-10 max-w-[368px] mt-4 mb-6" />
        <div
          className="text-body-1 text-gray-70 font-body font-normal xl:pr-[110px]"
          dangerouslySetInnerHTML={{
            __html: props.description ? props.description : "Texto no disponible.",
          }}
        />
      </div>
      <div className="grid grid-cols-2 gap-4 md:gap-6 pt-[128px] md:pt-8">
        <button
          onClick={() => props.cancel()}
          className="btn btn-secondary btn-large w-full"
        >
          Cancelar
        </button>
        <button onClick={()=>props.next()} className="btn btn-primary btn-large w-full">Continuar</button>
      </div>
    </>
  );
}
